(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    // Optional: Add JavaScript to debug on iOS
  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    document.addEventListener('DOMContentLoaded', function() {
      const logo = document.querySelector('.header-logo');
      if (logo) {
        console.log('iOS Logo Debug:');
        console.log('Logo width:', logo.offsetWidth);
        console.log('Logo parent width:', logo.parentElement.offsetWidth);
        console.log('Logo computed style:', window.getComputedStyle(logo));
        
        // Force re-center on load
        setTimeout(() => {
          logo.style.transform = 'translateX(-50%)';
        }, 100);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
